import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const settingListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}setting?sort_order=asc`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const updateSettingApi = async (payload) => {
    const request = requestAuthOption("PUT", payload)
    try {
        const response = await fetch(
            `${server}setting`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const pointListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}point`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const updatePointApi = async (payload) => {
    const request = requestAuthOption("PUT", payload.data)
    try {
        const response = await fetch(
            `${server}point/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};